'use client';
import { useState } from 'react';
import styles from './Informations.module.scss';
import type { Props } from './Informations.types';

const Informations = ({ tabs, children}: Props) => {
  const [selectedTab, setSelectedTab] = useState(children.findIndex((item) => item));
  // Render nothing when no tab has content (e.g. a bundle with no description/reviews),
  // otherwise the empty tabs shell leaves a blank section on the page.
  if (!children.some((item) => item)) return null;
  return (
    <section className={styles['Informations']}>
      <div className={styles['tabs']}>
        {children.map(
          (item, i) =>
            item && (
              <button
                data-active={i === selectedTab}
                key={i}
                onClick={() => setSelectedTab(i)}
                className={i === selectedTab ? styles['active'] : ''}
              >
                {tabs[i]}
              </button>
            )
        )}
      </div>
      <div>{children[selectedTab]}</div>
    </section>
  );
};

export default Informations;
